// src/hooks/useAccessOverrideVersion.js
// React hook to re-render components whenever Cust/Whs overrides change.

import { useEffect, useState } from "react";
import { ACCESS_OVERRIDE_EVENT } from "../utils/accessPreferenceStore";

export default function useAccessOverrideVersion() {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const handler = () => setVersion((value) => value + 1);
    if (typeof window !== "undefined" && window.addEventListener) {
      window.addEventListener(ACCESS_OVERRIDE_EVENT, handler);
    }
    return () => {
      if (typeof window !== "undefined" && window.removeEventListener) {
        window.removeEventListener(ACCESS_OVERRIDE_EVENT, handler);
      }
    };
  }, []);

  return version;
}
